// extracted by mini-css-extract-plugin
export var optionGrid = "_6s-7";
export var optionList = "_6s-6";
export var questionsBlock = "_6s-9";
export var spacer = "_6s-5";
export var stepCenteredContent = "_6s-3";
export var stepInner = "_6s-0";
export var stepInnerFullWidth = "_6s-1";
export var stepInnerLockScroll = "_6s-2";
export var stepTransitionFrame = "_6s-4";
export var welcomeBlock = "_6s-8";